var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVertN(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "33px",
    viewBox: "0 0 19 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vert_n") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "library",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04a_book_reader_settings",
    transform: "translate(-770.000000, -707.000000)",
    fill: "#AAAAAA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M764.5,714 L794.5,714 C795.328427,714 796,714.671573 796,715.5 C796,716.328427 795.328427,717 794.5,717 L764.5,717 C763.671573,717 763,716.328427 763,715.5 C763,714.671573 763.671573,714 764.5,714 Z M764.5,722 L787.24,722 C788.068427,722 788.74,722.671573 788.74,723.5 C788.74,724.328427 788.068427,725 787.24,725 L764.5,725 C763.671573,725 763,724.328427 763,723.5 C763,722.671573 763.671573,722 764.5,722 Z M764.5,730 L791.2,730 C792.028427,730 792.7,730.671573 792.7,731.5 C792.7,732.328427 792.028427,733 791.2,733 L764.5,733 C763.671573,733 763,732.328427 763,731.5 C763,730.671573 763.671573,730 764.5,730 Z",
    id: "vert_n",
    transform: "translate(779.500000, 723.500000) rotate(90.000000) translate(-779.500000, -723.500000) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertN);
export default __webpack_public_path__ + "static/media/vert_n.1195457f8fdc3ea12b21f1e521da4d66.svg";
export { ForwardRef as ReactComponent };